window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 1.5,
      sliderAutoplay = e.dataset.autoplay,
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime);

    if (sliderAutoplay == "true") {
      autoPlayValue = {
        delay: autoPlayTime,
      };
    }

    if (loopSelector == "true") {
      loopInit = true;
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseFloat(e.dataset.showExtraLarge);
      mobileShow = 1.5;
      if (typeof e.dataset.showTablet !== "undefined") {
        tabletShow = e.dataset.showTablet;
      } else {
        tabletShow = extraLargeDesktopShow;
      }
    } else {
      sliderContainer = false;
    }
    console.log("mobileShow",mobileShow);
    var featuredCollection = new Swiper(sliderContainer, {
      loop: true,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      autoplay: autoPlayValue,
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
        type: "fraction",
      },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        0: { 
          slidesPerView: 1.5, 
        },
        640: {
          slidesPerView: 1.5,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });

    featuredCollection.on('slideChangeTransitionEnd', function () {
      console.log("reupdating");
      featuredCollection.update(); // Force Swiper to recalculate slide widths
    });

    if (!sliderContainer == false && sliderAutoplay == "true") {
      sliderContainer.addEventListener("mouseenter", (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener("mouseleave", (e) => {
        featuredCollection.autoplay.start();
      });
    }
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  headerMainMenu.register("header", theme.headerMainMenuModule);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("accordion", theme.accordion);
  sections.register("blog", theme.blog);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});

// document.addEventListener("DOMContentLoaded", function () {
//     const variantRadios = document.querySelector("variant-radios");
//     if (!variantRadios) return;

//     variantRadios.addEventListener("change", function () {
  
//         const selectedVariantId = variantRadios.querySelector('input[type="radio"]:checked')?.value;
//         if (!selectedVariantId) return;
//         console.log("selectedVariantId",selectedVariantId);
//         window.location.reload();
//         // fetch(`/products/{{ product.handle }}.js`)
//         //     .then(response => response.json())
//         //     .then(data => {
//         //         const selectedVariant = data.variants.find(v => v.id == selectedVariantId);
//         //         if (!selectedVariant) return;

//         //         // Update the metafield content (ensure your div has id `variant-text-content`)
//         //         const variantContentDiv = document.querySelector("#variant-text-content");
//         //         if (variantContentDiv) {
//         //             variantContentDiv.textContent = selectedVariant.metafields?.custom?.transformative_content || "No content available";
//         //         }

//         //         // Update Images (Optional)
//         //         const productImage = document.querySelector("#variant-image");
//         //         if (productImage && selectedVariant.featured_image) {
//         //             productImage.src = selectedVariant.featured_image.src;
//         //         }
//         //     })
//         //     .catch(error => console.error("Error fetching variant data:", error));
//     });
// });

 // document.addEventListener("DOMContentLoaded", function() {
 //    let collapsibles = document.querySelectorAll(".collapsabledropdown .collapsible");

 //    collapsibles.forEach(button => {
 //      button.addEventListener("click", function() {
 //        this.classList.toggle("active");
 //        let content = this.nextElementSibling;
 //        content.classList.toggle("show");
 //      });
 //    });
 //  });

function isMobile() {
  return window.innerWidth <= 768; // Adjust breakpoint if needed
}

function isCollectionPage() {
  return window.location.pathname.includes('/collections');
}

function menuDrawerExists() {
  return document.querySelector('menu-drawer.mobile-facets__wrapper') !== null;
}
function isHeaderSticky() {
  return document.querySelector('.header__sticky.sticky') !== null;
}

function updateFixedPosition1() {
  console.log("inside",`${410 - window.scrollY}px`);
  let fixedElement = document.querySelector('.facets-container.scroll-trigger.animate--fade-in');
  if(window.scrollY != 0){
    if(isHeaderSticky()){
        fixedElement.style.setProperty('top', `${410 - window.scrollY - document.querySelector('.header__sticky.sticky').clientHeight}px`);
    }
    else{
      fixedElement.style.setProperty('top', `${410 - window.scrollY}px`);
    }
    
  }
  else{
    fixedElement.style.setProperty('top', '410px');
  }
  
}
function updateFixedPosition() {
  let fixedElement = document.querySelector('.facets-container.scroll-trigger.animate--fade-in');
  let gridContainer = document.querySelector('.product-grid-container.scroll-trigger.animate--slide-in');

  if (fixedElement && gridContainer) {
    let fixedHeight = fixedElement.clientHeight + 10; // Get height of fixed element
    let gridTop = gridContainer.getBoundingClientRect().top; // Get grid position relative to document top
    console.log("gridContainer.getBoundingClientRect().top",gridContainer.getBoundingClientRect().top);
    let newTop = gridTop - fixedHeight; // Set top value to be above gridContainer
    console.log("newTop",newTop);
    fixedElement.style.setProperty('top', `${newTop}px`);
  }
}


document.addEventListener("DOMContentLoaded", function () {
    let collapsibles = document.querySelectorAll(".collapsabledropdown .collapsible");

    collapsibles.forEach(button => {
        button.addEventListener("click", function () {
            // Close all other accordion items
            collapsibles.forEach(otherButton => {
                if (otherButton !== this) {
                    otherButton.classList.remove("active");
                    otherButton.nextElementSibling.classList.remove("show");
                }
            });

            // Toggle the clicked item
            this.classList.toggle("active");
            this.nextElementSibling.classList.toggle("show");
        });
    });


  const searchInput = document.getElementById('Search-In-Header');
  let isTyping = false; // To handle user's manual typing
  let typingInterval;   // To store interval reference

  // Fetch product names
  async function fetchProducts() {
    const response = await fetch('/products.json');
    const data = await response.json();
    return data.products.map(product => product.title);
  }

  // Typing effect function
  async function typeEffect() {
    //const products = await fetchProducts();
    const products=["Vitamin C Face Wash","Boro Neem Talcum Powder","Charcoal Face Wash","Face Wash","Face Cream","XICE Talcum Powder","Cream","Talcum Powder","Sunscreen Gel Cream","Fruit Glow Cream","Soft Moisturizing Cream","Rosemary Hair Spray","Rosemary Hair Shampoo","Rosemary Hair Oil","Divyaratna Hair Oil","Rose-Strawberry Hair Removal Cream","Hair Removal Cream","Body Lotion","Amla Hair Oil","Color Plus Family Shampoo","Lip Balm","Lip Jelly","Hair Oil","Shampoo"];

    let productIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    // Clear any existing interval before starting a new one
    clearInterval(typingInterval);

    typingInterval = setInterval(() => {
      if (isTyping) return; // Stop typing effect when user types manually
      
      const currentProduct = products[productIndex];

      if (!isDeleting) {
        searchInput.placeholder = `Search ${currentProduct.slice(0, charIndex)}`;
        charIndex++;
      } else {
        searchInput.placeholder = `Search ${currentProduct.slice(0, charIndex)}`;
        charIndex--;
      }

      // Move to next product after typing complete
      if (charIndex > currentProduct.length) {
        isDeleting = true;
      }

      // Switch to next product after deleting complete
      if (charIndex === 0 && isDeleting) {
        isDeleting = false;
        productIndex = (productIndex + 1) % products.length;
      }
    }, isDeleting ? 50 : 100); // Typing and deleting speed
  }

  // Event Listener to pause the effect when user types manually
  searchInput.addEventListener('input', () => {
    isTyping = searchInput.value.length > 0;
  });

  // Pause typing when user focuses on input field
  searchInput.addEventListener('focus', () => {
    isTyping = true;
  });

  // Resume typing effect when input is empty or user leaves input field
  searchInput.addEventListener('blur', () => {
    if (searchInput.value === '') {
      isTyping = false;
      typeEffect(); // Restart the typing effect
    }
  });

  typeEffect(); // Start the effect on page load


  if (isMobile() && isCollectionPage() && menuDrawerExists()) {
    console.log("✅ Conditions met: Mobile, Collection Page, and <menu-drawer> exists");
    window.addEventListener('scroll', updateFixedPosition);
    window.addEventListener('resize', updateFixedPosition);
    updateFixedPosition();
    setTimeout(function(){updateFixedPosition();},1000);
  }
});


  
